module.exports = __webpack_public_path__ + "02699f6bc632bb0b59dd72c8cf195fb4.pdf";